
export const messages = {

    sk: {
        overview: {
            titlePrefix: "Nákup u obchodníka",
            subTitle: "Popis platby",
            title: 'Názov',
            description: "Popis",
            url: "Web stránka",
            myAccount: "Zaplatiť z účtu",
            amount: "Suma",
            targetAccount: "Na číslo protiúčtu",
            variableSymbol: "Variabilný symbol",
            specificSymbol: "Špecifický symbol",
            dropdownDefault: "Vyberte účet",
            buttonSign: "Podpísať platbu",
            buttonAbort: "Návrat bez zaplatenia",
            bic: "BIC - SWIFT kód",
            payeeRef: "Referencia platiteľa",
            recipientMsg: "Správa pre prijímateľa",
            afterPaymentPrefix: "Disponibilný zostatok po zaplatení",
            errors: {
                diffError: "Na účte nemáte dostačujúci disponibilný zostatok.",
                noAccountSelectedError: "Nevybrali ste žiadny účet.",
                noAccountAvailError: "Nemáte žiaden účet vhodný pre zadanie e-platby. Vráťte sa na stránku obchodníka bez zaplatenia."
            }
        },
        sign: {
            title: "Podpis",
            ibanPrefix: "IBAN",
            textPrefix: "Text",
            processText: "Začínam podpisovací proces...",
            methods: {
                SMS: "SMS",
                GRID_CARD: "GRID karta",
                CASE_MOBILE: "mToken",
                GEORGE_TOKEN: "George aplikácia",
                gridPlaceholder: "GRID",
                mTokenPlaceholder: "mToken kód",
            },
            errors: {
                wrongKeyError: "Prepáčte, ale váš kľúč je nesprávny. Prosím, zopakujte svoj pokus.",
                mTokenFailedError: "Podpis mTokenom bol neúspešný.",
                authorisationLimitExceeded: "Prekročený alebo nedostatočný limit autorizačnej metódy."
            },
            smsKeyAck: "Poslali sme vám SMS na číslo %phone%. Kľúč má ID %id% a vyprší za %time% sek.",
            mTokenAck: "Transakciu potvrdíte pomocou aplikácie mToken vo vašom telefóne.",
            georgeIdAck: "Transakciu potvrdíte pomocou aplikácie George vo vašom telefóne.",
            mTokenAckNoPhone1: "Ak váš telefón nie je pripojený na internet, ",
            mTokenAckNoPhone2: "prosím naskenujte QR kód.",
            smsKeyAckExpired: "Váš kľúč vypršal.",
            gridKeyAck: "Zadajte požadovanú hodnotu z vašej GRID karty.",
            smsLabel: "Prosím vložte svoj SMS kód",
            smsSendLabel: "Na podpísanie použijete SMS kľúč.",
            useMtokenLabel: "Potvrďte transakciu v aplikácii mToken.",
            useGeorgeLabel: "Potvrďte transakciu v aplikácii George.",
            gridGenLabel: "Na podpísanie použijete GRID kartu.",
            noneLabel: "Vašu transakciu som vyhodnotil ako bezpečnú, nie je potrebné ďalšie overenie.",
            genGrid: "Vygenerovať súradnice",
            useMtoken: "Použiť mToken",
            useGeorge: "Použiť George",
            gridLabel: "Prosím, vložte svoj GRID kód",
            mTokenLabel: "Zadajte offline mToken kód",
            georgeLabel: "Zadajte offline George kód",
            sendSms: "Poslať SMS",
            sendNone: "Potvrdiť",
            submit: "Potvrdiť",
            info: "Po potvrdení bude vaša transakcia podpísaná.",
            hint: "Ak máte akúkoľvek otázku, prosím kontaktujte Klientske centrum:<br aria-hidden='true' />E-mail: info{'@'}slsp.sk<br aria-hidden='true' />Tel.č: 0850 111 888 (zo zahraničia <span class='custom-a11y__wrapper'><span class='custom-a11y__label' aria-label='+ 4 2 1 9 1 0 1 1 1 8 8 8'></span><span aria-hidden='true'>+421 910 111 888</span></span>).<br aria-hidden='true' />Ďakujeme!"
        },
        modals: {
            close: "Zavrieť",
            process: {
                title: "Spracovávam...",
                caption: "Prosím, počkajte na výsledok platby.",
                button: "Návrat k obchodníkovi"
            },
            failed: {
                title: "Niekde sa stala chyba...",
                caption: "Mrzí nás to, ale platbu sa nepodarilo zrealizovať.",
                errorIdLabel: "Identifikátor chyby: ",
                button: "Návrat k obchodníkovi"
            },
            blockedInvestigation: {
                title: "Niekde sa stala chyba...",
                caption: "Transakciu je potrebné overiť telefonicky. Prosím, volajte linku Klientskeho centra 0800 111 188 (zo zahraničia +421 910 111 188).",
                button: "Návrat k obchodníkovi"
            },
            blockedFraud: {
                title: "Niekde sa stala chyba...",
                caption: "Transakcia bola zablokovaná. Bližšie informácie získate na linke Klientskeho centra 0800 111 188 (zo zahraničia +421 910 111 188).",
                button: "Návrat k obchodníkovi"
            },
            skOrderBlockedFps: {
                title: "Váš účet sme dočasne zablokovali kvôli podozrivej platbe.",
                caption: "Skôr, ako zadáte ďalšiu transakciu, prosím, autorizujte alebo odmietnite podozrivú platbu na linke Klientskeho centra 0800 111 188 (zo zahraničia +421 910 111 188).",
                button: "Návrat k obchodníkovi",
            },
            noAuthAvailable: {
                title: "Niekde sa stala chyba...",
                caption: "Proces nie je možné dokončiť. Nemáte k dispozícií bezpečnostný predmet - mToken, prosím aktivujte si ho na podpis, alebo ste prekročili limit bezpečnostného predmetu, v takom prípade to skúste znova nasledujúci deň.",
                button: "Návrat k obchodníkovi"
            },
            authLimitExceeded: {
                title: "Niekde sa stala chyba...",
                caption: "Proces nie je možné dokončiť. Nemáte k dispozícií bezpečnostný predmet - mToken, prosím aktivujte si ho na podpis, alebo ste prekročili limit bezpečnostného predmetu, v takom prípade to skúste znova nasledujúci deň.",
                button: "Návrat k obchodníkovi"
            },
            timeout: {
                title: "Niekde sa stala chyba...",
                caption: "Platnosť stránky vypršala.",
                button: "Návrat k obchodníkovi"
            },
            success: {
                title: "Hotovo!",
                caption: "Platba bola úspešne zrealizovaná. Automaticky vás presmerujem <br aria-hidden='true' >na stránku obchodníka.",
                button: "Návrat k obchodníkovi"
            },
            noAuth: {
                title: "Niekde sa stala chyba...",
                caption: "Pre žiadny z vašich účtov nie je momentálne s použitým bezpečnostným predmetom tento distribučný kanál prístupný. Kontaktujte, prosím, vašu pobočku.",
                button: "Návrat k obchodníkovi"
            },
            notSignable: {
              title: "Niekde sa stala chyba...",
              caption: "Je mi to ľúto, ale počas podpisovania došlo k chybe. Prosím, skúste to opäť neskôr.",
              button: "Návrat k obchodníkovi"
            },
            preventReturn: {
                title: "Niekde sa stala chyba...",
                caption: "Mrzí nás to, ale platbu sa nepodarilo zrealizovať.",
                errorIdLabel: "Identifikátor chyby: ",
                button: "Ukončiť",
                buttonUrl: 'https://www.slsp.sk/sk/configuration/error-pages/sporopay-nezhoda-udajov',
            }
        },
        adhocModals: {
            fetch: {
                process: {
                    title: "Spracovávam...",
                    caption: "Prosím počkajte, načítavam Vaše údaje.",
                }
            }
        },
        icon: {
            info: 'Ikonka informácie',
            warning: 'Ikonka upozornenia',
        }
    },

    en: {
        overview: {
            titlePrefix: "Purchase at the merchant",
            subTitle: "Payment description",
            title: 'Title',
            description: "Description",
            url: "Web page",
            myAccount: "Pay from account",
            amount: "Amount",
            targetAccount: "To offset number",
            variableSymbol: "Variable symbol",
            specificSymbol: "Specific symbol",
            dropdownDefault: "Select account",
            buttonSign: "Sign payment",
            buttonAbort: "Return without paying",
            bic: "BIC - SWIFT code",
            payeeRef: "Payee reference",
            recipientMsg: "Message for receiver",
            afterPaymentPrefix: "Disposable amount after payment",
            errors: {
                diffError: "You don't have sufficient disposable balance on your account.",
                noAccountSelectedError: "You have not selected an account.",
                noAccountAvailError: "You have no account suitable for performing e-payment. Please return to merchant without paying."
            }
        },
        sign: {
            title: "Sign",
            ibanPrefix: "IBAN",
            textPrefix: "Text",
            processText: "I am starting Signing Process...",
            methods: {
                SMS: "SMS",
                GRID_CARD: "GRID card",
                CASE_MOBILE: "mToken",
                GEORGE_TOKEN: "George aplikácia",
                gridPlaceholder: "GRID",
                mTokenPlaceholder: "mToken code",
            },
            errors: {
                wrongKeyError: "We're sorry, but your key is not correct. Please, try again.",
                mTokenFailedError: "mToken signing was unsuccessful.",
                authorisationLimitExceeded: "Exceeded or insufficient limit of authorization method."
            },
            smsKeyAck: "We have sent you an SMS to number %phone%. The key is ID %id% and expires in %time% sec.",
            mTokenAck: "Confirm the transaction using mToken application in your phone.",
            georgeIdAck: "Confirm the transaction using George application in your phone.",
            mTokenAckNoPhone1: "If your phone has no internet connection, ",
            mTokenAckNoPhone2: "please scan QR code.",
            smsKeyAckExpired: "Your key has expired.",
            gridKeyAck: "Please enter grid code from coordinates below.",
            smsLabel: "Please insert your SMS code",
            smsSendLabel: "You will use an SMS key to sign on to your mobile phone.",
            useMtokenLabel: "Confirm the transaction in mToken application.",
            useGeorgeLabel: "Confirm the transaction in George application.",
            gridGenLabel: "You will use a GRID card code to sign on to your mobile phone.",
            noneLabel: "I have evaluated your transaction as safe and no further validations are required.",
            genGrid: "Generate coordinates",
            useMtoken: "Use mToken",
            useGeorge: "Use George",
            gridLabel: "Please insert your GRID code",
            mTokenLabel: "Insert your offline mToken code",
            sendSms: "Send SMS",
            sendNone: "Confirm",
            submit: "Submit",
            info: "Your transaction will be signed after submitting.",
            hint: "If you have any questions, please contact the Client Center:<br/>E-mail: info{'@'}slsp.sk<br aria-hidden='true' />Phone: 0850 111 888 (from abroad <span class='custom-a11y__wrapper'><span class='custom-a11y__label' aria-label='+ 4 2 1 9 1 0 1 1 1 8 8 8'></span><span aria-hidden='true'>+421 910 111 888</span></span>).<br aria-hidden='true' />Thank you!"
        },
        modals: {
            close: "Close",
            process: {
                title: "Loading...",
                caption: "Please, wait for payment to be completed.",
                button: "Return to merchant"
            },
            failed: {
                title: "Something went wrong...",
                caption: "We're sorry, but your payment could not be completed.",
                errorIdLabel: "Error ID: ",
                button: "Return to merchant"
            },
            blockedInvestigation: {
                title: "Something went wrong...",
                caption: "The transaction is to be verified by phone. Please, call the Call Centre hotline at 0800 111 188 (+421 910 111 188 from abroad).",
                button: "Return to merchant"
            },
            blockedFraud: {
                title: "Something went wrong...",
                caption: "The transaction was blocked. You can get more detailed information by calling the Client centre at 0800 111 188 (+421 910 111 188 from abroad).",
                button: "Return to merchant"
            },
            skOrderBlockedFps: {
                title: "We have detected suspicious payment activity on your account and as a result, it has been temporarily blocked.",
                caption: "Before entering another payment, please authorise or reject the suspicious payment by calling the Client centre hotline at 0800 111 188 (from abroad +421 910 111 188).",
                button: "Return to merchant",
            },
            noAuthAvailable: {
                title: "Something went wrong...",
                caption: "The payment cannot be completed. You do not have a security item - mToken or George, please activate it for signing, or you have exceeded the limit of the security item, in which case try again the next day.",
                button: "Return to merchant"
            },
            authLimitExceeded: {
                title: "Something went wrong...",
                caption: "The payment cannot be completed. You do not have a security item - mToken or George, please activate it for signing, or you have exceeded the limit of the security item, in which case try again the next day.",
                button: "Return to merchant"
            },
            timeout: {
                title: "Something went wrong...",
                caption: "Your session has expired.",
                button: "Return to merchant"
            },
            success: {
                title: "Done!",
                caption: "Payment was successful. We will automatically redirect you <br aria-hidden='true' >to merchant's website.",
                button: "Return to merchant"
            },
            noAuth: {
                title: "Something went wrong...",
                caption: "None of your accounts currently have access to this distribution channel with the security object in use. Please contact your branch.",
                button: "Return to merchant"
            },
            notSignable: {
              title: "Something went wrong...",
              caption: "We're sorry, but an error occurred while signing. Please try again later.",
              button: "Return to merchant"
            }
        },
        adhocModals: {
            fetch: {
                process: {
                    title: "Loading...",
                    caption: "Please wait until we fetch your data.",
                }
            }
        },
        icon: {
            info: 'Info icon',
            warning: 'Warning icon',
        }
    }

};
